/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { KTSVG } from '../../../../_metronic/helpers';
// import DropPage from '../../../../_metronic/partials/DropPage';
// import Pagination from '../../../../_metronic/partials/Pagination';
// import { GetTenantDetails } from '../../../../redux/apis/tenantAPIs';
import { setHeader } from '../../../../redux/features/common-slice';

import NoResultsFound from '../NoResultsFound';
import StatusTag from '../StatusTag';
// import { PORTAL_TYPES } from '../../../constants/roles';
import { useDebounce } from '../../../../_metronic/helpers';
import {
    checkOrderEmail,
    // getOrderDetails,
    // updateOrderStatus
} from '../../../../redux/apis/ordersAPIs';
import { useParams } from 'react-router';
// import { showSuccess } from '../../../utils/sweetAlert';
import { createSalesSheet, createSheet, fixDecimal, formatCommaNumber, ImageSizeChange } from '../../../functions/operations';
// import { accountInformation, getTaxInfo } from '../../../../redux/apis/configurationAPIs';
import {
    KeyValueLoader,
    Loader
} from '../../../functions/SkeletonLoaderComponents';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Repeat from '../../../functions/Repeat';
// import TableFooterSkeleton from '../../../functions/TableFooterSkeleton';
import { formatPhoneNumber } from '../../../utils/libphonenumber';
import LoaderOverlay from '../loader/LoaderOverlay';
// import { getCityListWithoutPaginaiton, getRegionList } from '../../../../redux/apis/regionsAPIs';
import configuration from '../../../constants/configuration';
import { useSearchParams } from 'react-router-dom';
import { DealLableOrderItem } from '../Deals/DealLableOrderItem';
import { accountInformation } from '../../../../redux/apis/configurationAPIs';

const OrderEmail = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const dir = i18n.dir();
    const loading: any = useSelector((state: any) => state?.orders?.loading);
    const listingLoading: any = useSelector(
        (state: any) => state?.orders?.listingLoading
    );
    const [searchKey, setSearchKey] = useState<any>('');
    const params: any = useParams();
    const [searchParams] = useSearchParams();
    const currentPage: any = useSelector(
        (state: any) => state?.orders?.currentPageItem
    );
    const [includeTax, setIncludeTax] = useState<any>(true);
    const [firstLoad, setFirstLoad] = useState(true);
    const orderDetailsByAPI = useSelector((state: any) => {
        return state.orders.orderInfo;
    });
    const orderItemList: any = useSelector((state: any) => {
        return state?.orders?.orderItemInfo;
    });
    const countryInfo: any = useSelector((state: any) => {
        return state?.orders?.countryInfo;
    });
    const [orderItems, setorderItems] = useState<any>([]);
	const currentRole = useSelector((state: any) => state.auth.currentRole);
    // const orderDetailsByAPI = useSelector((state: any) => {
    //     return state.orders.orderDetails;
    // });
    // const orderItemList: any = useSelector((state: any) => {
    //     return state?.orders?.orderItemList;
    // });
    const dispatch = useDispatch();
    useEffect(() => {
        processOrderItems();
    }, [orderItemList]);
    useEffect(() => {
        checkOrder();
        setFirstLoad(true);
        dispatch(setHeader(t('order_details')));
        getAppSetting();
        // getListOfCity();
        // callAPIforShippingLabel();
        // DetailsOfTenant(currentRole?.tenant_id?._id);
        // (async function () {
        //     const data: any = {};
        //     data.tenantId = currentRole?.tenant_id?._id;
        //     const { payload } = await dispatch(getTaxInfo(data));
        //     setIncludeTax(() => payload?.price == 'INCLUDE');
        // })();
    }, []);

	const getAppSetting = async () => {
		const data: any = { type: configuration.appSetting };
		data.tenantId = currentRole?.tenant_id?._id;
		if (data.tenantId) {
			await dispatch(accountInformation(data));
		}
    };

    const checkOrder = async () => {
        const data: any = {}
        data.token = searchParams.get('token');
        data.orderId = params?.id;
        const res = await dispatch(checkOrderEmail(data));
    };
    const processOrderItems = () => {
        const newItems: any = [];
        const clone = structuredClone(orderItemList);
        clone.forEach((items: any) => {
            if (items?.deal_info) {
                const currentItem = structuredClone(items);
                if (currentItem?.deal_info?.deal_type === 'BULK_PRICING') {
                    currentItem.original_price =
                        currentItem?.deal_info.bulk_price;
                }
                if (currentItem?.deal_info?.deal_type === 'DISCOUNT') {
                    currentItem.original_price =
                        currentItem?.deal_info.discounted_price;
                }
                newItems.push(currentItem);
                const modifyItem = structuredClone(items);
                if (modifyItem?.deal_info?.deal_type === 'BUY_X_AND_GET_Y') {
                    modifyItem.quantity =
                        modifyItem?.deal_info.free_item_count;
                    modifyItem.original_price = 0;
                    modifyItem.dealGiftItem = true;
                    newItems.push(modifyItem);
                }
            } else {
                newItems.push(items);
            }
        });
        setorderItems(newItems);
    };
    const getTaxData = () => {
        const data: any = { type: 'tax', taxes: [] };
        if (orderDetailsByAPI?.tax_calculation_info) {
            for (const key in orderDetailsByAPI?.tax_calculation_info) {
                if (orderDetailsByAPI?.tax_calculation_info[key]) {
                    const taxData = structuredClone(
                        orderDetailsByAPI?.tax_calculation_info[key]
                    );
                    const object: any = {
                        name: taxData?.tax_name,
                        amount:
                            formatCommaNumber(fixDecimal(taxData?.calculated_tax)) +
                            ' ' +
                            countryInfo?.country?.currency,
                        groupTax: []
                    };
                    if (taxData?.type === 'GROUP') {
                        for (const innerKey in taxData.group_taxes) {
                            const innerData = structuredClone(
                                taxData.group_taxes[innerKey]
                            );
                            const innerObject = {
                                name: innerData?.tax_name,
                                amount:
                                    formatCommaNumber(
                                        fixDecimal(innerData?.calculated_tax)
                                    ) +
                                    ' ' +
                                    countryInfo?.country?.currency
                            };
                            object.groupTax.push(innerObject);
                        }
                    }
                    data.taxes.push(object);
                }
            }
        }
        return data;
    };
    const ordersDetail = [
        {
            id: 1,
            name: 'order_number',
            value: orderDetailsByAPI.order_number
        },
        {
            id: 2,
            name: 'sales_person',
            value: orderDetailsByAPI.sales_person_name
        },
        {
            id: 3,
            name: 'order_type',
            value: orderDetailsByAPI.order_app_type
        },
        {
            id: 4,
            name: 'source',
            value:
                (orderDetailsByAPI.order_punching_device_type || '') +
                '•' +
                (orderDetailsByAPI.order_punching_device_os || '')
        },
        {
            id: 5,
            name: 'subtotal',
            value: formatCommaNumber(fixDecimal(orderDetailsByAPI.total_amount)) + " " + (countryInfo?.country?.currency)
        },
        // {
        //     id: 6,
        //     name: orderDetailsByAPI?.tax_calculation_info?.tax_name,
        //     value: fixDecimal(orderDetailsByAPI.total_amount)+" "+(countryInfo?.country?.currency)
        // },
        { ...getTaxData() },
        {
            id: 7,
            name: 'total_amount',
            value: formatCommaNumber(fixDecimal(
                (orderDetailsByAPI.total_amount || 0) +
                (orderDetailsByAPI.total_tax || 0)
            )) + " " + (countryInfo?.country?.currency)
        },
        {
            id: 8,
            name: 'status',
            value: orderDetailsByAPI.order_status
        }
    ];

    const ship_to_arr = [
        {
            id: 1,
            name: 'customer',
            value: orderDetailsByAPI.customer_name
        },
        {
            id: 2,
            name: 'region',
            value: orderDetailsByAPI.region_name
        },
        {
            id: 3,
            name: 'city',
            value: orderDetailsByAPI.city_name
        },
        {
            id: 4,
            name: 'contact_person',
            value: orderDetailsByAPI.customer_primary_contact_name
        },
        {
            id: 5,
            name: 'mobile_number',
            value: formatPhoneNumber(
                orderDetailsByAPI.shipping_country_code,
                orderDetailsByAPI.shipping_mobile_number
            )
            // (orderDetailsByAPI.shipping_country_code || '') + (orderDetailsByAPI.shipping_mobile_number || '')
        }
    ];
    const RowsTableSkeletonMobile = ({ count }: any) => {
        return (
            <Repeat numTimes={count}>
                {(index: any) => (
                    <>
                        <tr key={index} className='system-users-table-row height-72px'>
                            <td className='min-w-40px' style={{ width: '70px' }}>
                                <Skeleton height='20px' width='100%' />
                            </td>
                            <td className='min-w-70px' style={{ width: '70px' }}>
                                <Skeleton height='20px' width='100%' />
                            </td>
                        </tr>
                    </>
                )}
            </Repeat>
        );
    };
    const RowsTableSkeleton = ({ count }: any) => {
        return (
            <Repeat numTimes={count}>
                {(index: any) => (
                    <tr
                        key={index}
                        className="system-users-table-row height-72px"
                    >
                        <th className="min-w-125px">
                            <Skeleton height="20px" width="100%" />
                        </th>
                        <th style={{ minWidth: '300px' }}>
                            <div className="d-flex align-items-center">
                                <Skeleton
                                    height="50px"
                                    width="50px"
                                    className="me-3"
                                    inline={true}
                                />
                                <div style={{ flex: 1 }}>
                                    <Skeleton height="20px" width="100%" />
                                </div>
                            </div>
                        </th>
                        <th className="min-w-70px">
                            <Skeleton height="20px" width="100%" />
                        </th>
                        <th className="min-w-40px">
                            <Skeleton height="20px" width="100%" />
                        </th>
                        <th className="min-w-50px ">
                            <Skeleton height="20px" width="100%" />
                        </th>
                    </tr>
                )}
            </Repeat>
        );
    };

    const status = [
        {
            "name": "RECEIVED",
            "class": "info"
        },
        {
            "name": "PREPARING",
            "class": "warning"
        },
        {
            "name": "SHIPPED",
            "class": "success"
        },
        {
            "name": "DELIVERED",
            "class": "light"
        }
    ]

    const tabs = ['order', 'details', 'progress'];

    return (
        <div className="system-users-wrapper">
            <div className="row">
                <div className="col-md-12 col-lg-12 col-xl-9">
                    {/* mobile */}
                    <div className='d-sm-block d-md-none'>
                        {loading && firstLoad ? (
                            <Loader height="40px" width="60px" />
                        ) : (
                            <div style={{ width: '100%', background: '#FFFFFF', padding: '20px 0 0 0', overflow: 'hidden' }}>
                                <table style={{ borderCollapse: 'collapse', borderSpacing: 0, width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            {/* {orderDetailsByAPI?.order_status_track
                                                ?.map((item: any) => item)
                                                ?.map(
                                                    (
                                                        items: any,
                                                        index: any,
                                                        row: any
                                                    ) => ( */}
                                            {status
                                                ?.map(
                                                    (
                                                        items: any,
                                                        index: any
                                                    ) => (
                                                        <td style={{ width: '25%', textAlign: 'center', padding: 0, position: 'relative' }}>
                                                            {/* <table style={{ borderCollapse: 'collapse', borderSpacing: 0, width: '100%' }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ padding: 0 }}> */}
                                                                            <div className="mb-5" style={{ position: 'relative', height: '60px', textAlign: 'center' }}>
                                                                                {/* Progress bar connector - extends from right edge of current circle to next cell */}
                                                                                {index < status.length - 1 && (
                                                                                    <div
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '10px',
                                                                                            left: 'calc(50%)',
                                                                                            width: '100%',
                                                                                            height: '4px',
                                                                                            backgroundColor:
                                                                                                orderDetailsByAPI?.order_status_track?.some((track: any) => track?.order_status === status[index + 1]?.name)
                                                                                                    ? 'var(--kt-primary)'
                                                                                                    : 'var(--kt-gray-700)',
                                                                                            borderRadius: '2px',
                                                                                            zIndex: 0
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                                {/* Status circle and label */}
                                                                                <div style={{ position: 'relative', zIndex: 1 }}>
                                                                                    {orderDetailsByAPI?.order_status_track?.some((track: any) => track?.order_status === items?.name)
                                                                                        ?
                                                                                        <>
                                                                                            <img
                                                                                                src="https://hawak-dev-public.s3.me-south-1.amazonaws.com/hawak-dev/template-images/checked-status.png"
                                                                                                style={{ width: "24px", height: "24px", marginBottom: "10px" }}
                                                                                            />
                                                                                            <p className='text-primary'>
                                                                                                {t(items?.name?.toLowerCase())}
                                                                                            </p>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <img
                                                                                                src="https://hawak-dev-public.s3.me-south-1.amazonaws.com/hawak-dev/template-images/status.png"
                                                                                                style={{ width: "24px", height: "24px", marginBottom: "10px" }}
                                                                                            />
                                                                                            <p className='text-muted'>
                                                                                                {t(items?.name?.toLowerCase())}
                                                                                            </p>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        {/* </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table> */}
                                                        </td>
                                                    ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                    <div
                        className="card system-user-details-card card-flush d-sm-block d-md-none"
                        style={{
                            // padding: '30px',
                            // marginTop: '24px'
                        }}
                    >
                        <div
                            className="bg-gray-200 p-5 fs-18px fw-bolder text-gray-800 d-flex align-items-center"
                            id="kt_accordion_1_header_1"
                            data-bs-toggle="collapse"
                            data-bs-target="#kt_accordion_1_body_1"
                            aria-expanded="false"
                            aria-controls="kt_accordion_1_body_1"
                        >
                            {loading ? (
                                <Skeleton
                                    height="35px"
                                    width="50px"
                                    className="me-3"
                                />
                            ) : (
                                <button
                                    className=" accordion-button fs-2 fw-bolder text-capitalize collapsed"
                                    type="button"
                                >
                                    {t("order_info")}
                                </button>
                            )}
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr073.svg"
                                className="svg-icon-2 ms-auto me-0 cursor-pointer"
                            />
                        </div>
                        <div
                            id="kt_accordion_1_body_1"
                            className={`accordion-collapse show px-5 py-1`}
                            aria-labelledby="kt_accordion_1_header_1"
                            data-bs-parent="#kt_accordion_1"
                        >
                            <div className="card system-user-details-card card-flush p-0 h-100">
                                <div className="card-body system-user-details-card-body p-0 mt-6">
                                    {loading ? (
                                        <SkeletonTheme
                                            borderRadius="6px"
                                            baseColor="var(--kt-gray-300)"
                                            highlightColor="var(--kt-light)"
                                        >
                                            <RowsTableSkeleton count="2" />
                                        </SkeletonTheme>
                                    ) : (
                                        <>
                                            <div className="marginBottom-16px fv-row w-100 d-flex justify-content-between">
                                                <label className="form-label lh-21px">
                                                    {t(
                                                        'order_number'
                                                    )}:
                                                </label>
                                                <span>{orderDetailsByAPI?.order_number}</span>
                                            </div>
                                            <div className="marginBottom-16px fv-row w-100 d-flex justify-content-between">
                                                <label className="form-label">
                                                    {t(
                                                        'order_date'
                                                    )}:
                                                </label>
                                                <span>
                                                    {moment(
                                                        orderDetailsByAPI?.created_at
                                                    ).format(
                                                        'DD/MM/YYYY'
                                                    )
                                                        // +' ' +
                                                        // moment(
                                                        // 	orderDetailsByAPI?.created_at
                                                        // ).format(
                                                        // 	'hh:mm A')
                                                    }
                                                </span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div
                            className="bg-gray-200 p-5 fs-18px fw-bolder text-gray-800 d-flex align-items-center"
                            id="kt_accordion_2_header_2"
                            data-bs-toggle="collapse"
                            data-bs-target="#kt_accordion_2_body_2"
                            aria-expanded="false"
                            aria-controls="kt_accordion_2_body_2"
                        >
                            {loading ? (
                                <Skeleton
                                    height="35px"
                                    width="50px"
                                    className="me-3"
                                />
                            ) : (
                                <button
                                    className="accordion-button fs-2 fw-bolder text-capitalize collapsed"
                                    type="button"
                                >
                                    {t("delivery_address")}
                                </button>
                            )}
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr073.svg"
                                className="svg-icon-2 ms-auto me-0 cursor-pointer"
                            />
                        </div>
                        <div
                            id="kt_accordion_2_body_2"
                            className={`accordion-collapse show px-5 py-1`}
                            aria-labelledby="kt_accordion_2_header_2"
                            data-bs-parent="#kt_accordion_2"
                        >
                            <div className="card system-user-details-card card-flush p-0 h-100">
                                <div className="card-body system-user-details-card-body p-0 mt-6">
                                    {loading ? (
                                        <SkeletonTheme
                                            borderRadius="6px"
                                            baseColor="var(--kt-gray-300)"
                                            highlightColor="var(--kt-light)"
                                        >
                                            <RowsTableSkeleton count="4" />
                                        </SkeletonTheme>
                                    ) : (
                                        <>
                                            <div className="marginBottom-16px fv-row w-100 d-flex justify-content-between">
                                                <label className="form-label lh-21px">
                                                    {t(
                                                        'address'
                                                    )}:
                                                </label>
                                                <span className="text-end">{orderDetailsByAPI?.shipping_address}</span>
                                            </div>
                                            <div className="marginBottom-16px fv-row w-100 d-flex justify-content-between">
                                                <label className="form-label">
                                                    {t(
                                                        'region'
                                                    )}:
                                                </label>
                                                <span>{orderDetailsByAPI?.region_name}</span>
                                            </div>
                                            <div className="marginBottom-16px fv-row w-100 d-flex justify-content-between">
                                                <label className="form-label">
                                                    {t('city')}:
                                                </label>
                                                <span>{orderDetailsByAPI?.city_name}</span>
                                            </div>
                                            <div className="marginBottom-16px fv-row w-100 d-flex justify-content-between">
                                                <label className="form-label lh-21px">
                                                    {t(
                                                        'mobile_number'
                                                    )}:
                                                </label>
                                                <span>{orderDetailsByAPI?.shipping_mobile_number}</span>
                                                {/* <div className="phone-number border-6">
                                                </div> */}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div
                            className="bg-gray-200 p-5 fs-18px fw-bolder text-gray-800 d-flex align-items-center"
                            id="kt_accordion_3_header_3"
                            data-bs-toggle="collapse"
                            data-bs-target="#kt_accordion_3_body_3"
                            aria-expanded="false"
                            aria-controls="kt_accordion_3_body_3"
                        >
                            {loading ? (
                                <Skeleton
                                    height="35px"
                                    width="50px"
                                    className="me-3"
                                />
                            ) : (
                                <button
                                    className="accordion-button fs-2 fw-bolder text-capitalize collapsed"
                                    type="button"
                                >
                                    {t("order_details")}
                                </button>
                            )}
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr073.svg"
                                className="svg-icon-2 ms-auto me-0 cursor-pointer"
                            />
                        </div>
                        <div
                            id="kt_accordion_3_body_3"
                            className={`accordion-collapse show px-5 py-1`}
                            aria-labelledby="kt_accordion_3_header_3"
                            data-bs-parent="#kt_accordion_3"
                        >
                            <div className="card system-user-details-card card-flush p-0 h-100">
                                <div className="card-body system-user-details-card-body p-0 mt-6">
                                    <div
                                        className='table-responsive d-sm-block d-md-none '
                                        style={{
                                            borderBottom:
                                                '1px solid var(--kt-gray-200)'
                                        }}
                                    >
                                        <table className=' table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                                            <thead>
                                                {listingLoading && firstLoad ? (
                                                    <SkeletonTheme
                                                        borderRadius='6px'
                                                        baseColor='var(--kt-gray-300)'
                                                        highlightColor='var(--kt-light)'
                                                    >
                                                        <tr className='system-users-table-row fw-bolder text-muted'>
                                                            <td
                                                                className='min-w-40px'
                                                                style={{ width: '70px' }}
                                                            >
                                                                <Skeleton
                                                                    height='20px'
                                                                    width='100%'
                                                                />
                                                            </td>
                                                            <td
                                                                className='min-w-70px'
                                                                style={{ width: '70px' }}
                                                            >
                                                                <Skeleton
                                                                    height='20px'
                                                                    width='100%'
                                                                />
                                                            </td>
                                                        </tr>
                                                    </SkeletonTheme>
                                                ) : (
                                                    <>
                                                        <tr className='system-users-table-row fw-bolder text-muted'>
                                                            <th className='min-w-70px'>
                                                                {t('item')}
                                                            </th>
                                                            <th className='min-w-70px text-end'>
                                                                {t('amount')}
                                                            </th>
                                                        </tr>
                                                    </>
                                                )}
                                            </thead>
                                            <tbody>
                                                {!listingLoading && orderItems?.length == 0 && (
                                                    <tr>
                                                        <td className='text-center p-0' colSpan={12}>
                                                            <NoResultsFound />
                                                        </td>
                                                    </tr>
                                                )}
                                                {loading && firstLoad ? (
                                                    <SkeletonTheme
                                                        borderRadius='6px'
                                                        baseColor='var(--kt-gray-300)'
                                                        highlightColor='var(--kt-light)'
                                                    >
                                                        <RowsTableSkeletonMobile count='5' />
                                                    </SkeletonTheme>
                                                ) : (
                                                    orderItems?.length > 0 &&
                                                    orderItems?.map((product: any, index: number) => {
                                                        return (
                                                            <tr
                                                                key={product?._id + index}
                                                                className='system-users-table-row'
                                                                style={{
                                                                    minHeight: '71px',
                                                                    height: 'auto'
                                                                }}
                                                            >
                                                                <td className='text-gray-800 fw-normal fs-6'>
                                                                    <div>
                                                                        <div className='pt-1 d-flex'>
                                                                            {product
                                                                                ?.dealGiftItem ? (
                                                                                <>
                                                                                    <KTSVG
                                                                                        path='/media/icons/duotune/general/arrow-turn-down-right.svg'
                                                                                        className={`svg-icon-2 d-flex me-5 radius-6 justify-content-center align-items-center`}
                                                                                    />
                                                                                    <KTSVG
                                                                                        path='/media/icons/duotune/general/gift.svg'
                                                                                        className={`svg-icon-2 d-flex me-5 radius-6  justify-content-center align-items-center`}
                                                                                    />
                                                                                </>
                                                                            ) : (
                                                                                <img
                                                                                    src={
                                                                                        product
                                                                                            ?.productImgInfo
                                                                                            ?.cover_image
                                                                                            ?.s3_url
                                                                                            ? ImageSizeChange(
                                                                                                product
                                                                                                    ?.productImgInfo
                                                                                                    ?.cover_image
                                                                                                    ?.s3_url,
                                                                                                'thumbnail'
                                                                                            ) +
                                                                                            '?timestamp=' +
                                                                                            Date.now()
                                                                                            : product
                                                                                                ?.productImgInfo
                                                                                                ?.group_cover_image
                                                                                                ?.s3_url
                                                                                                ? ImageSizeChange(
                                                                                                    product
                                                                                                        ?.productImgInfo
                                                                                                        ?.group_cover_image
                                                                                                        ?.s3_url,
                                                                                                    'thumbnail'
                                                                                                ) +
                                                                                                '?timestamp=' +
                                                                                                Date.now()
                                                                                                : product
                                                                                                    ?.productImgInfo
                                                                                                    ?.parent_cover_image
                                                                                                    ?.s3_url
                                                                                                    ? ImageSizeChange(
                                                                                                        product
                                                                                                            ?.productImgInfo
                                                                                                            ?.parent_cover_image
                                                                                                            ?.s3_url,
                                                                                                        'thumbnail'
                                                                                                    ) +
                                                                                                    '?timestamp=' +
                                                                                                    Date.now()
                                                                                                    : '/media/image_logo.png'
                                                                                    }
                                                                                    alt='image_logo'
                                                                                    className='me-5 radius-6 w-50px h-50px'
                                                                                />
                                                                            )}
                                                                            {product
                                                                                ?.deal_info && (
                                                                                    <div>
                                                                                        <DealLableOrderItem
                                                                                            dealData={
                                                                                                product
                                                                                                    // ?.order_items
                                                                                                    ?.deal_info
                                                                                            }
                                                                                            product={
                                                                                                product
                                                                                            }
                                                                                            currency={
                                                                                                countryInfo?.country?.currency
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                        <div
                                                                            className=' cursor-pointer pt-2'
                                                                        // onClick={() =>
                                                                        //     navigateToProducts(
                                                                        //         product
                                                                        //     )
                                                                        // }
                                                                        >
                                                                            <span className='text-gray-600 fw-normal d-block fs-6'>
                                                                                {
                                                                                    product
                                                                                        // ?.order_items
                                                                                        ?.item_number
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                        <div className='pt-2'>
                                                                            <span className='text-gray-800 fw-normal d-block fs-6'>
                                                                                {dir === 'rtl'
                                                                                    ? product
                                                                                        // ?.order_items
                                                                                        ?.product_secondary_name +
                                                                                    (product
                                                                                        // ?.order_items
                                                                                        ?.variant_secondary_name
                                                                                        ? ' - '
                                                                                        : '') +
                                                                                    (product
                                                                                        // ?.order_items
                                                                                        ?.group_secondary_name
                                                                                        ? product
                                                                                            // ?.order_items
                                                                                            ?.group_secondary_name +
                                                                                        ' / '
                                                                                        : ' ') +
                                                                                    (product
                                                                                        // ?.order_items
                                                                                        ?.variant_secondary_name
                                                                                        ? product
                                                                                            // ?.order_items
                                                                                            ?.variant_secondary_name
                                                                                        : '')
                                                                                    : product
                                                                                        // ?.order_items
                                                                                        ?.product_name +
                                                                                    (product
                                                                                        // ?.order_items
                                                                                        ?.variant_name
                                                                                        ? ' - '
                                                                                        : '') +
                                                                                    (product
                                                                                        // ?.order_items
                                                                                        ?.group_name
                                                                                        ? product
                                                                                            // ?.order_items
                                                                                            ?.group_name +
                                                                                        ' / '
                                                                                        : ' ') +
                                                                                    (product
                                                                                        // ?.order_items
                                                                                        ?.variant_name
                                                                                        ? product
                                                                                            // ?.order_items
                                                                                            ?.variant_name
                                                                                        : '')}
                                                                                {/* variant_name,product_secondary_name */}
                                                                            </span>
                                                                        </div>
                                                                        {product
                                                                            ?.deal_info && (
                                                                                <div
                                                                                    className='pt-2'
                                                                                    style={{
                                                                                        fontSize: '12px'
                                                                                    }}
                                                                                >
                                                                                    #
                                                                                    {
                                                                                        product
                                                                                            // ?.order_items
                                                                                            ?.deal_info
                                                                                            ?.deal_name
                                                                                    }
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </td>
                                                                <td className='text-gray-800 fw-normal fs-6 text-end'>
                                                                    <div className=''>
                                                                        <div>
                                                                            {product
                                                                                ?.quantity +
                                                                                ' ' +
                                                                                t('pcs')}
                                                                        </div>
                                                                        <div className='py-6'>
                                                                            {formatCommaNumber(
                                                                                fixDecimal(
                                                                                    Number(
                                                                                        product
                                                                                            // ?.order_items
                                                                                            ?.original_price
                                                                                    )
                                                                                )
                                                                            ) +
                                                                                ' ' +
                                                                                countryInfo?.country?.currency}
                                                                        </div>
                                                                        <div>
                                                                            {formatCommaNumber(
                                                                                fixDecimal(
                                                                                    Number(
                                                                                        product
                                                                                            // ?.order_items
                                                                                            ?.original_price *
                                                                                        product
                                                                                            // ?.order_items
                                                                                            .quantity
                                                                                    )
                                                                                )
                                                                            ) +
                                                                                ' ' +
                                                                                countryInfo?.country?.currency}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* {loading ? (
                                        <SkeletonTheme
                                            borderRadius="6px"
                                            baseColor="var(--kt-gray-300)"
                                            highlightColor="var(--kt-light)"
                                        >
                                            <RowsTableSkeleton count="5" />
                                        </SkeletonTheme>
                                    ) : (
                                                    <div className="table-responsive">
                                                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                                            {orderItemList?.length > 0 &&
                                                            orderItemList?.map(
                                                            (product: any, index: number) => {
                                                                return (
                                                                <tr
                                                                    key={index}
                                                                    className="system-users-table-row"
                                                                    style={{
                                                                        minHeight: '71px',
                                                                        height: 'auto'
                                                                    }}
                                                                >
                                                                <td className="text-gray-800 fw-normal fs-6 mw-80px">
                                                                    {dir === 'rtl'
                                                                        ? product
                                                                            ?.product_secondary_name +
                                                                        (product
                                                                            ?.variant_secondary_name
                                                                            ? ' - '
                                                                            : '') +
                                                                        (product
                                                                            ?.group_secondary_name
                                                                            ? product
                                                                                ?.group_secondary_name +
                                                                            ' / '
                                                                            : ' ') +
                                                                        (product
                                                                            ?.variant_secondary_name
                                                                            ? product
                                                                                ?.variant_secondary_name
                                                                            : '')
                                                                        : product
                                                                            ?.product_name +
                                                                        (product
                                                                            ?.variant_name
                                                                            ? ' - '
                                                                            : '') +
                                                                        (product
                                                                            ?.group_name
                                                                            ? product
                                                                                ?.group_name +
                                                                            ' / '
                                                                            : ' ') +
                                                                        (product
                                                                            ?.variant_name
                                                                            ? product
                                                                                ?.variant_name
                                                                            : '')}
                                                                </td>
                                                                <td className="text-gray-800 fw-normal text-center m-3 radius-6 fs-14px mw-20px" style={{background: 'var(--kt-active-bg)'}}>
                                                                    {product?.quantity}
                                                                </td>
                                                                <td className="text-gray-800 fw-normal fs-6 text-end mw-30px">
                                                                    {product?.original_price} {countryInfo?.country?.currency}
                                                                </td>
                                                            </tr>
                                                            )})}
                                                        </table>
                                                    </div>
                                    )} */}
                                    <div className="my-4 fv-row w-100">
                                        <label className="form-label fs-16px">
                                            {t(
                                                'order_summary'
                                            )}
                                        </label>
                                    </div>
                                    <div className="fv-row w-100 d-flex justify-content-between">
                                        <label className="form-label ">
                                            {t('total before VAT')}
                                        </label>
                                        <span className="">
                                            {fixDecimal(orderDetailsByAPI?.total_amount)}
                                        </span>
                                    </div>
                                    <div className="fv-row w-100 d-flex justify-content-between"
                                        style={{
                                            borderBottom:
                                                '1px solid var(--kt-gray-200)'
                                        }}>
                                        <label className="form-label ">
                                            {t('VAT')}
                                        </label>
                                        <span className="">
                                            {fixDecimal(orderDetailsByAPI?.total_tax)}
                                        </span>
                                    </div>
                                    <div className="my-4 fv-row w-100 d-flex justify-content-between">
                                        <label className="form-label ">
                                            {t('total_amount')}
                                        </label>
                                        <span className="">
                                            {fixDecimal(
                                                (orderDetailsByAPI?.total_amount || 0) +
                                                (orderDetailsByAPI?.total_tax || 0)
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="card table-card d-none d-sm-none d-md-block"
                        style={{ position: 'relative' }}
                    >
                        {listingLoading && !firstLoad && (
                            <LoaderOverlay bgColor={'var(--kt-card-bg)'} />
                        )}
                        {/* <div className="card-header border-0 pt-5 p-0"> */}
                        {/* <Search /> */}
                        {/* <div className="d-flex align-items-center order-last w-100"> */}
                        {/* <div className="d-flex align-items-center ms-auto">
                                    {listingLoading && firstLoad && (
                                        <Loader height="44px" width="176px" />
                                    )}
                                    <div
                                        className={
                                            listingLoading && firstLoad
                                                ? 'd-none'
                                                : ''
                                        }
                                    >
                                        {!['CANCELLED', 'DELIVERED'].includes(
                                            orderDetailsByAPI?.order_status
                                        ) && (
                                                <OrdersDetailsDropDown
                                                    onAction={updateStatus}
                                                    currentStatus={
                                                        orderDetailsByAPI.order_status
                                                    }
                                                />
                                            )}
                                    </div>
                                    <div className={orderDetailsByAPI?.order_status !== 'SHIPPED' ? 'd-none' : ''}>
                                        <OrdersDetailsActionsDropDown onAction={(e: any) => actionProcess(e)} />
                                    </div>
                                </div> */}
                        {/* </div> */}
                        {/* </div> */}
                        <div className="table-responsive">
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead>
                                    <tr className="system-users-table-row fw-bolder text-muted">
                                        {listingLoading && firstLoad ? (
                                            <>
                                                <SkeletonTheme
                                                    borderRadius="6px"
                                                    baseColor="var(--kt-gray-300)"
                                                    highlightColor="var(--kt-light)"
                                                >
                                                    <th className="min-w-125px">
                                                        <Skeleton
                                                            height="20px"
                                                            width="100%"
                                                        />
                                                    </th>
                                                    <th
                                                        style={{
                                                            minWidth: '300px'
                                                        }}
                                                    >
                                                        <Skeleton
                                                            height="20px"
                                                            width="100%"
                                                        />
                                                    </th>
                                                    <th className="min-w-70px">
                                                        <Skeleton
                                                            height="20px"
                                                            width="100%"
                                                        />
                                                    </th>
                                                    <th className="min-w-40px">
                                                        <Skeleton
                                                            height="20px"
                                                            width="100%"
                                                        />
                                                    </th>
                                                    <th className="min-w-50px ">
                                                        <Skeleton
                                                            height="20px"
                                                            width="100%"
                                                        />
                                                    </th>
                                                </SkeletonTheme>
                                            </>
                                        ) : (
                                            <>
                                                <th className="min-w-125px">
                                                    {t('item_number')}
                                                </th>
                                                <th
                                                    style={{
                                                        minWidth: '300px'
                                                    }}
                                                >
                                                    {t('product_title')}
                                                </th>
                                                <th className="min-w-70px">
                                                    {t('qty')}
                                                </th>
                                                <th className="min-w-40px">
                                                    {t('price')}
                                                </th>
                                                <th className="min-w-50px ">
                                                    {t('subtotal')}
                                                </th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {!listingLoading &&
                                        orderItems?.length === 0 && (
                                            <tr>
                                                <td
                                                    className="text-center p-0"
                                                    colSpan={7}
                                                >
                                                    <NoResultsFound />
                                                </td>
                                            </tr>
                                        )}
                                    {listingLoading && firstLoad ? (
                                        <SkeletonTheme
                                            borderRadius="6px"
                                            baseColor="var(--kt-gray-300)"
                                            highlightColor="var(--kt-light)"
                                        >
                                            <RowsTableSkeleton count="5" />
                                        </SkeletonTheme>
                                    ) : (
                                        orderItems?.length > 0 &&
                                        orderItems?.map(
                                            (product: any, index: number) => {
                                                return (
                                                    <tr
                                                        key={index}
                                                        className="system-users-table-row"
                                                        style={{
                                                            minHeight: '71px',
                                                            height: 'auto'
                                                        }}
                                                    >
                                                        <td className="text-gray-800 fw-normal fs-6">
                                                            <div
                                                                className={`${product
                                                                    ?.dealGiftItem &&
                                                                    'd-flex'
                                                                    }`}
                                                            >
                                                                {product
                                                                    ?.dealGiftItem && (
                                                                        <span className='inline-block me-3'>
                                                                            <KTSVG
                                                                                path='/media/icons/duotune/general/arrow-turn-down-right.svg'
                                                                                className={`svg-icon-2`}
                                                                            />
                                                                        </span>
                                                                    )}
                                                                <span className='text-gray-800 fw-normal d-block fs-6'>
                                                                    {product?.item_number}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className="d-flex align-items-center border-bottom-0 text-gray-800 fw-normal fs-6">
                                                            {product?.dealGiftItem ? (
                                                                <KTSVG
                                                                    path='/media/icons/duotune/general/gift.svg'
                                                                    className={`svg-icon-2 d-flex me-5 radius-6 w-50px h-50px justify-content-center align-items-center`}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={
                                                                        product
                                                                            ?.productImgInfo
                                                                            ?.cover_image
                                                                            ?.s3_url
                                                                            ? product
                                                                                ?.productImgInfo
                                                                                ?.cover_image
                                                                                ?.s3_url +
                                                                            '?timestamp=' +
                                                                            Date.now()
                                                                            : product
                                                                                ?.productImgInfo
                                                                                ?.group_cover_image
                                                                                ?.s3_url
                                                                                ? ImageSizeChange(
                                                                                    product
                                                                                        ?.productImgInfo
                                                                                        ?.group_cover_image
                                                                                        ?.s3_url,
                                                                                    'thumbnail'
                                                                                ) +
                                                                                '?timestamp=' +
                                                                                Date.now()
                                                                                : product
                                                                                    ?.productImgInfo
                                                                                    ?.parent_cover_image
                                                                                    ?.s3_url
                                                                                    ? product
                                                                                        ?.productImgInfo
                                                                                        ?.parent_cover_image
                                                                                        ?.s3_url +
                                                                                    '?timestamp=' +
                                                                                    Date.now()
                                                                                    : '/media/image_logo.png'
                                                                    }
                                                                    alt="image_logo"
                                                                    className="me-5 radius-6 w-50px h-50px"
                                                                />
                                                            )}
                                                            <span className="text-gray-800 fw-normal d-block fs-6">
                                                                {/* {dir === "rtl"
                                                                ? product?.secondary_language_title ?? ""
                                                                : "100-Piece Tool Set with 13mm Impact Drill 810W"} */}
                                                                {dir === 'rtl'
                                                                    ? product
                                                                        ?.product_secondary_name +
                                                                    (product
                                                                        ?.variant_secondary_name
                                                                        ? ' - '
                                                                        : '') +
                                                                    (product
                                                                        ?.group_secondary_name
                                                                        ? product
                                                                            ?.group_secondary_name +
                                                                        ' / '
                                                                        : ' ') +
                                                                    (product
                                                                        ?.variant_secondary_name
                                                                        ? product
                                                                            ?.variant_secondary_name
                                                                        : '')
                                                                    : product
                                                                        ?.product_name +
                                                                    (product
                                                                        ?.variant_name
                                                                        ? ' - '
                                                                        : '') +
                                                                    (product
                                                                        ?.group_name
                                                                        ? product
                                                                            ?.group_name +
                                                                        ' / '
                                                                        : ' ') +
                                                                    (product
                                                                        ?.variant_name
                                                                        ? product
                                                                            ?.variant_name
                                                                        : '')}
                                                                {product?.deal_info && (
                                                                    <DealLableOrderItem
                                                                        dealData={product?.deal_info}
                                                                        product={product}
                                                                        currency={countryInfo?.country?.currency}
                                                                    />
                                                                )}
                                                                {/* variant_name,product_secondary_name */}
                                                            </span>
                                                        </td>
                                                        <td className="text-gray-800 fw-normal fs-6">
                                                            {
                                                                product?.quantity
                                                            }
                                                        </td>
                                                        <td className="text-gray-800 fw-normal fs-6">
                                                            {formatCommaNumber(
                                                                fixDecimal(
                                                                    Number(
                                                                        product?.original_price
                                                                    )
                                                                )
                                                            )} {/* {includeTax
                                                                ? fixDecimal(
                                                                    Number(
                                                                        (+product
                                                                            ?.base_price ||
                                                                            0) +
                                                                        (+product
                                                                            ?.tax ||
                                                                            0)
                                                                    )
                                                                )
                                                                : fixDecimal(
                                                                    Number(
                                                                        +product
                                                                            ?.base_price ||
                                                                        0
                                                                    )
                                                                )} */}
                                                        </td>
                                                        <td className="text-gray-800 fw-normal fs-6 text-end">
                                                            {formatCommaNumber(
                                                                fixDecimal(
                                                                    Number(
                                                                        product?.original_price *
                                                                        product?.quantity
                                                                    )
                                                                )
                                                            )}
                                                            {product
                                                                ?.deal_info && (
                                                                    <div
                                                                        className='mt-2'
                                                                        style={{
                                                                            fontSize: '10px',
                                                                            position: 'absolute',
                                                                            right: '30px'
                                                                        }}
                                                                    >
                                                                        #
                                                                        {
                                                                            product?.deal_info
                                                                                ?.deal_name
                                                                        }
                                                                    </div>
                                                                )}
                                                            {/* {fixDecimal(
                                                                Number(
                                                                    includeTax
                                                                        ? (+product
                                                                            ?.base_price +
                                                                            (+product
                                                                                ?.tax ||
                                                                                0)) *
                                                                        product
                                                                            ?.quantity
                                                                        : +product
                                                                            ?.base_price *
                                                                        product
                                                                            ?.quantity
                                                                )
                                                            )} */}
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="table-footer">
                            {loading && firstLoad ? (
                                <div className="w-100">
                                    <TableFooterSkeleton />
                                </div>
                            ) : (
                                <>
                                    <div>
                                        <DropPage
                                            arr={[10, 20, 30]}
                                            setPerPage={setPerPage}
                                            setPage={setPage}
                                            count={count}
                                            perPage={perPage}
                                        />
                                    </div>
                                    <Pagination
                                        setPage={setPage}
                                        perPage={perPage}
                                        page={page}
                                        count={count}
                                    />
                                </>
                            )}
                        </div> */}
                    </div>
                </div>
                <div className="col-md-12 col-lg-12 col-xl-3 d-none d-sm-none d-md-block">
                    <div className="card mt-6 mt-xl-0">
                        <div className="card-body d-flex flex-column customer-details">
                            {loading && firstLoad ? (
                                <KeyValueLoader count={8} title={true} />
                            ) : (
                                <>
                                    <div className="w-100 fs-18px mb-5">
                                        <label className="text-gray-800 fw-600 line-heigth-21p fs-17px marginBottom-6 ">
                                            {t('order_details')}
                                        </label>
                                    </div>
                                    {ordersDetail.map(
                                        (items: any, index: any, row: any) => (
                                            <div
                                                className={`fv-row d-flex w-100 align-items-center ${(index + 1 === row.length || items?.taxes?.length === 0)
                                                    ? ''
                                                    : 'pb-4 mb-4 img-border-bottom'
                                                    }`}
                                                key={items.id}
                                            >
                                                <div className={'justify-content-between w-100 ' + (items.type === 'tax' ? '' : 'd-flex')} >
                                                    {items.type === 'tax' ?
                                                        <>
                                                            {items.taxes.map((taxDetail: any) => (
                                                                <>
                                                                    <div className='w-100 d-flex justify-content-between'>
                                                                        <label
                                                                            className="text-gray-800 text-switch fs-13px p-0 me-auto"
                                                                            style={{ flex: 1 }}
                                                                        >
                                                                            {t(taxDetail?.name)}
                                                                        </label><span
                                                                            className="text-gray-800 fw-600 text-switch fs-13px p-0 text-end"
                                                                            style={{ flex: 1 }}
                                                                        >
                                                                            {taxDetail?.amount}
                                                                        </span>
                                                                    </div>
                                                                    {(taxDetail.groupTax.length > 0) && <>

                                                                        {taxDetail.groupTax.map((taxInnerDetail: any) => (
                                                                            <>
                                                                                <div className='w-100 d-flex justify-content-between'>
                                                                                    <label
                                                                                        className="text-gray-600 text-switch fs-13px p-0 me-auto  ms-2"
                                                                                        style={{ flex: 1 }}
                                                                                    >
                                                                                        {t(taxInnerDetail?.name)}
                                                                                    </label><span
                                                                                        className="text-gray-600 fw-600 text-switch fs-13px p-0 text-end"
                                                                                        style={{ flex: 1 }}
                                                                                    >
                                                                                        {taxInnerDetail?.amount}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ))}
                                                                    </>}
                                                                </>
                                                            ))}
                                                        </>
                                                        :
                                                        <>
                                                            <label
                                                                className="text-gray-800 text-switch fs-13px p-0 me-auto"
                                                                style={{ flex: 1 }}
                                                            >
                                                                {t(items?.name)}
                                                            </label>
                                                            <span
                                                                className="text-gray-800 fw-600 text-switch fs-13px p-0 text-end"
                                                                style={{ flex: 1 }}
                                                            >
                                                                {items.name ===
                                                                    'status' ? (
                                                                    <StatusTag
                                                                        label={t(
                                                                            items?.value?.toLowerCase() ||
                                                                            ''
                                                                        )}
                                                                        type={
                                                                            items?.value ===
                                                                                'PREPARING'
                                                                                ? 'warning'
                                                                                : items?.value ===
                                                                                    'SHIPPED'
                                                                                    ? 'success'
                                                                                    : items?.value ===
                                                                                        'DELIVERED'
                                                                                        ? 'light'
                                                                                        : items?.value ===
                                                                                            'RECEIVED'
                                                                                            ? 'info'
                                                                                            : 'danger'
                                                                        }
                                                                        className={`system-users-list-status-tag radius-6 px-5 py-2 fw-normal`}
                                                                        style={{
                                                                            display:
                                                                                'inline-flex'
                                                                        }}
                                                                    />
                                                                ) : items?.value ===
                                                                    'SALES_APP' ? (
                                                                    'Salesperson'
                                                                ) : items?.value ===
                                                                    'CUSTOMER_APP' ? (
                                                                    'Customer'
                                                                ) : (
                                                                    items?.value
                                                                )}
                                                            </span>
                                                        </>
                                                    }

                                                </div>
                                            </div>
                                        )
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <div className="card mt-6">
                        <div className="card-body d-flex flex-column customer-details">
                            {loading && firstLoad ? (
                                <KeyValueLoader count={5} title={true} />
                            ) : (
                                <>
                                    <div className="w-100 fs-18px mb-5">
                                        <label className="text-gray-800 fw-600 line-heigth-21p fs-17px marginBottom-6 ">
                                            {t('ship_to')}
                                        </label>
                                    </div>
                                    {ship_to_arr.map(
                                        (items: any, index: any, row: any) => (
                                            <div
                                                className={`fv-row d-flex w-100 align-items-center ${index + 1 === row.length
                                                    ? ''
                                                    : 'pb-4 mb-4 img-border-bottom'
                                                    }`}
                                                key={items?.id}
                                            >
                                                <div className="d-flex justify-content-between w-100">
                                                    <label
                                                        className="text-gray-800 text-switch fs-13px p-0 me-auto"
                                                        style={{ flex: 1 }}
                                                    >
                                                        {t(items?.name)}
                                                    </label>
                                                    <span
                                                        className="text-gray-800 fw-600 text-switch fs-13px p-0 text-end"
                                                        style={{ flex: 1 }}
                                                    >
                                                        {items?.value}
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    {orderDetailsByAPI?.order_status_track?.length && (
                        <div className="card mt-6">
                            <div className="card-body d-flex flex-column customer-details">
                                {loading && firstLoad ? (
                                    <KeyValueLoader count={3} title={true} />
                                ) : (
                                    <>
                                        <div className="w-100 fs-18px mb-5">
                                            <label className="text-gray-800 fw-600 line-heigth-21p fs-17px marginBottom-6 ">
                                                {t('order_progress')}
                                            </label>
                                        </div>
                                        {orderDetailsByAPI?.order_status_track
                                            ?.map((item: any) => item)
                                            ?.reverse()
                                            ?.map(
                                                (
                                                    items: any,
                                                    index: any,
                                                    row: any
                                                ) => (
                                                    <div
                                                        className={`timeline-label custom-timeline ${index + 1 ===
                                                            row.length
                                                            ? 'last'
                                                            : ''
                                                            }`}
                                                        key={index}
                                                    >
                                                        {
                                                            <div
                                                                className={`timeline-item ${index +
                                                                    1 ===
                                                                    row.length
                                                                    ? 'mb-0'
                                                                    : 'mb-7'
                                                                    }`}
                                                                key={index}
                                                            >
                                                                {/* begin::Label */}
                                                                <div className="text-gray-800 text-switch fs-13px date-container">
                                                                    {moment(
                                                                        items?.time
                                                                    ).format(
                                                                        'DD/MM/YYYY'
                                                                    )}{' '}
                                                                    @{' '}
                                                                    {moment(
                                                                        items?.time
                                                                    ).format(
                                                                        'hh:mm A'
                                                                    )}
                                                                </div>
                                                                {/* end::Label */}
                                                                {/* begin::Badge */}
                                                                <div className="timeline-badge">
                                                                    <i
                                                                        className={`fa fa-genderless fs-1 text-${items?.order_status ===
                                                                            'PREPARING'
                                                                            ? 'danger'
                                                                            : items?.order_status ===
                                                                                'SHIPPED'
                                                                                ? 'success'
                                                                                : items?.order_status ===
                                                                                    'DELIVERED'
                                                                                    ? 'grey-600'
                                                                                    : items?.order_status ===
                                                                                        'RECEIVED'
                                                                                        ? 'primary'
                                                                                        : 'warning'
                                                                            }`}
                                                                    ></i>
                                                                </div>
                                                                {/* end::Badge */}
                                                                {/* begin::Content */}
                                                                <div className="timeline-content d-flex">
                                                                    <span
                                                                        className="fw-600 fs-13px ps-6"
                                                                        style={{
                                                                            color: 'var(--kt-gray-800)'
                                                                        }}
                                                                    >
                                                                        {t(
                                                                            items?.order_status?.toLowerCase()
                                                                        )}
                                                                    </span>
                                                                </div>
                                                                {/* end::Content */}
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            )}
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
export default OrderEmail;